import type { UserMfaPreferenceInput } from "@alaffia-technology-solutions/server/src/schema/types.generated";

import type {
  CreateUserInput,
  createUserMutation,
  SendUserOnboardNotificationInput,
  sendUserOnboardNotificationMutation,
  setUserMfaPreferenceMutation,
} from "../../remote/gql/graphql";
import type { ClientReturnType } from "../types";
import type { AlaffiaClientModuleArgs } from "./modules";

import { createUserMutationDoc } from "../../remote/mutations/createUser.gql";
import { sendUserOnboardNotificationMutationDoc } from "../../remote/mutations/sendUserOnboardNotification.gql";
import { setUserMfaPreferenceMutationDoc } from "../../remote/mutations/setUserMfaPreference.gql";
import { userTenantNameQueryDoc } from "../../remote/queries/getUserTenantName.gql";
import { AlaffiaClientModule } from "./modules";

type UsersModuleArgs = AlaffiaClientModuleArgs;

export class UsersModule extends AlaffiaClientModule {
  constructor(args: UsersModuleArgs) {
    super(args);
  }

  createUser = async (input: {
    input: CreateUserInput;
  }): ClientReturnType<createUserMutation["createUser"]> => {
    const result = await this.runGqlMutation(
      createUserMutationDoc,
      {
        input: input.input,
      },
      "createUser",
    );

    return {
      data: result.data?.createUser ?? null,
      error: result.error ?? null,
    };
  };

  getUserTenantName = async () => {
    const result = await this.runGqlQuery(
      userTenantNameQueryDoc,
      {},
      "getUserTenantName",
    );

    return {
      data: result.data?.userTenantName ?? null,
      error: result.error ?? null,
    };
  };

  sendUserOnboardNotification = async (
    input: SendUserOnboardNotificationInput,
  ): ClientReturnType<
    sendUserOnboardNotificationMutation["sendUserOnboardNotification"]
  > => {
    const result = await this.runGqlMutation(
      sendUserOnboardNotificationMutationDoc,
      {
        input: input,
      },
      "sendUserOnboardNotification",
    );

    return {
      data: result.data?.sendUserOnboardNotification ?? null,
      error: result.error ?? null,
    };
  };

  setUserMfaPreference = async (
    input: UserMfaPreferenceInput,
  ): ClientReturnType<setUserMfaPreferenceMutation["setUserMfaPreference"]> => {
    const result = await this.runGqlMutation(
      setUserMfaPreferenceMutationDoc,
      {
        input: input,
      },
      "setUserMfaPreference",
    );

    return {
      data: result.data?.setUserMfaPreference ?? null,
      error: result.error ?? null,
    };
  };
}
